import { startOfDay } from "date-fns";
import resolveDate, { ResolveDateOptions } from "./resolve-date";

const resolveStartOfDay = (
  date: Date | string | number,
  options?: ResolveDateOptions<typeof startOfDay>
) => resolveDate(startOfDay, date, options);

export default resolveStartOfDay;
